export default __webpack_public_path__ + "static/media/tennis-league-thumbnail.c64c6b92.png";